<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { getSortedAgentsByAvailability } from 'dashboard/helper/agentHelper';

import Policy from 'dashboard/components/policy.vue';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  contactId: { type: Number, required: true },
  assignee: { type: Object, default: null },
});

const { t } = useI18n();
const store = useStore();

const verifiedAgents = useMapGetter('agents/getVerifiedAgents');

onMounted(() => {
  store.dispatch('agents/get');
});

const noneAgent = computed(() => ({
  id: 0,
  name: t('AGENT_MGMT.MULTI_SELECTOR.LIST.NONE'),
  confirmed: true,
  role: 'agent',
  account_id: 0,
}));

const agentsList = computed(() => {
  const sortedAgents = getSortedAgentsByAvailability(
    verifiedAgents.value || []
  );
  return [noneAgent.value, ...sortedAgents];
});

const selectedAgent = computed(() => {
  if (!props.assignee?.id) return {};
  return (
    agentsList.value.find(agent => agent.id === props.assignee.id) ||
    props.assignee
  );
});

const assignContact = async agent => {
  const assigneeId = agent?.id && agent.id !== 0 ? agent.id : null;
  if (assigneeId === (props.assignee?.id || null)) return;

  try {
    await store.dispatch('contacts/update', {
      id: props.contactId,
      assigneeId,
    });
    useAlert(t('CONTACTS_LAYOUT.ASSIGNEE.SUCCESS_MESSAGE'));
  } catch {
    useAlert(t('CONTACTS_LAYOUT.ASSIGNEE.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <Policy :permissions="['administrator', 'supervisor']">
    <div class="w-52 shrink-0" @click.stop>
      <MultiselectDropdown
        :options="agentsList"
        :selected-item="selectedAgent"
        :multiselector-title="t('AGENT_MGMT.MULTI_SELECTOR.TITLE.AGENT')"
        :multiselector-placeholder="t('CONTACTS_LAYOUT.ASSIGNEE.PLACEHOLDER')"
        :no-search-result="
          t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.NO_RESULTS.AGENT')
        "
        :input-placeholder="
          t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.PLACEHOLDER.AGENT')
        "
        @select="assignContact"
      />
    </div>
  </Policy>
</template>
